






























import { Component, Vue, Prop } from "vue-property-decorator";

import { HeaderKeys } from "@/store/account/orders/enums";
import { OrderHeader, OrderItem } from "@/store/account/orders/types";
import { SortDirections } from "@/store/catalog/enums";

import Row from "./blocks/Row";
import Headers from "./blocks/Headers.vue";

// @TODO - success modal;

@Component({
  components: {
    Headers,
    Row,
  },
})
export default class OrderTable extends Vue {
  activeCell: HeaderKeys | null = null;
  selectedIds: number[] = [];

  @Prop({ type: Array, default: () => [] })
  readonly headers!: OrderHeader[];

  @Prop({ type: Array, default: () => [] })
  readonly items!: OrderItem[];

  @Prop({ type: String, default: "" })
  readonly sortKey!: HeaderKeys;

  @Prop({ type: String, default: SortDirections.DESC })
  readonly sortDirection!: SortDirections;

  get allSelected() {
    return this.ids.length === this.selectedIds.length;
  }

  get ids(): number[] {
    return this.items.map(item => item.id as number);
  }

  selectHandler({ id, value }: any) {
    if (id) {
      if (value) {
        this.selectedIds.push(id);
      } else {
        const ids = [...this.selectedIds];
        const match = ids.findIndex(item => item === id);
        ids.splice(match, 1);
        this.selectedIds = ids;
      }
      return;
    }
    this.selectedIds = value ? this.ids : [];
  }

  hoverHandler({ cell, state }: { cell: HeaderKeys; state: boolean }) {
    if (!state) {
      this.activeCell = null;
      return;
    }
    this.activeCell = cell;
  }
}
